let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("iIOsE")]).then(() => parcelRequire('9SG4h'));